if (!customElements.get('progress-bar')) {

  class ProgressBar extends HTMLElement {

    constructor() {
      super();

      // Options
      this.options = {
        "shipping_threshold": 5000,
        "currency": {
          "name": "British Pound",
          "iso_code": "GBP",
          "symbol": "£",
          "currency_format": "en-GB"
        },
        "translations": {
          "shipping_threshold_text": "{{ html }} away from free shipping",
          "reached_text": "You have reached free shipping"
        }
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      // elements
      this.elements = {
        content: this.querySelector('[data-progress-bar-content]'),
        header: this.querySelector('[data-progress-bar-header]'),
        bar: this.querySelector('[data-progress-bar]'),
        barInner: this.querySelector('[data-progress-bar-inner]'),
        footer: this.querySelector('.progress-bar__footer')
      }

    }

    /*
      Format currency amount based on the currency settings
      @param amount {number}: The amount to format (in cents)
      @return {string}: Formatted currency string
    */
    formatCurrency(amount) {
      const { symbol, iso_code } = this.options.currency;
      // Convert cents to units (e.g., 5000 cents to 50.00)
      const convertedAmount = amount / 100;

      try {
        // Try to use Intl.NumberFormat for localized formatting
        return new Intl.NumberFormat(this.options.currency.currency_format, {
          style: 'currency',
          currency: iso_code,
          currencyDisplay: 'symbol'
        }).format(convertedAmount);
      } catch (e) {
        // Fallback if Intl is not supported
        return `${symbol}${convertedAmount.toFixed(2)}`;
      }
    }

    /*
      Update the progress bar
      @param state {object}: state object received from cart update (cart.js)
    */
    update(state) {
      // get total price from state
      const { total_price } = state;
      // Get threshold
      const threshold = this.options.shipping_threshold;

      // Ensure threshold is valid
      if (!threshold || threshold <= 0) {
        this.classList.add('progress-bar--hidden');
        return;
      }

      // Determine if threshold reached
      const thresholdReached = total_price >= threshold;

      if (!thresholdReached) {
        // Calculate remaining amount to reach threshold
        const amountToGo = threshold - total_price;
        const formattedAmountToGo = this.formatCurrency(amountToGo);

        // Calculate progress percentage based on how close we are to the threshold
        // The percentage should be (current amount / threshold) * 100
        const progressPercent = Math.min(Math.round((total_price / threshold) * 100), 100);

        // Update header text with remaining amount
        const headerText = this.options.translations.shipping_threshold_text.replace('{{ html }}', formattedAmountToGo);
        this.elements.header.innerText = headerText;

        // Update progress bar width
        this.elements.barInner.style.width = `${progressPercent}%`;
        this.elements.bar.classList.remove('progress-bar__bar--reached');
        this.elements.bar.classList.add('progress-bar__bar--step-2');

        // Show progress bar
        this.style.height = `${this.elements.content.offsetHeight}px`;
        this.classList.remove('progress-bar--hidden');
      } else {
        // Threshold reached
        this.elements.header.innerText = this.options.translations.reached_text;
        this.elements.barInner.style.width = '100%';
        this.elements.bar.classList.add('progress-bar__bar--reached');
        this.elements.bar.classList.remove('progress-bar__bar--step-2');

        // Show progress bar
        this.style.height = `${this.elements.content.offsetHeight}px`;
        this.classList.remove('progress-bar--hidden');
      }
    }
  }

  window.ProgressBar = ProgressBar;

  customElements.define('progress-bar', ProgressBar);
}
